const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter:true,      
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter:true,      
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
        sorter:true,
    },
    // {
    //     title: 'KYC Status',
    //     dataIndex: 'kycStatus',
    // },   
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        sorter:true,
    }, 
    {
        title: 'Action',
        dataIndex: 'action',
    }

];

export default columns;